module.exports = __webpack_public_path__ + "static/img/ICPSindex.11a173b3.png";